export default __webpack_public_path__ + "static/media/creator-moji@2x.9f9cb09b.png";